/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const mealplanExperience = useStore((state) => state.mealplanExperience);
  const setMealplanExperience = useStore((state) => state.setMealplanExperience);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.mealplanExperience.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={mealplanExperience}
          onChange={(value) => {
            setMealplanExperience(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'mealplan-experience',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Yes, I tried one'}>
            <span>📋</span> {t('onboarding.mealplanExperience.options.triedOne')}
          </Option>
          <Option value={'Yes, I had several'}>
            <span>🍽️</span> {t('onboarding.mealplanExperience.options.hadSeveral')}
          </Option>
          <Option value={'Never used any'}>
            <span>🚫</span> {t('onboarding.mealplanExperience.options.neverUsed')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
